export default __webpack_public_path__ + "static/media/blue-drop-down-arrow.a342ed26.svg";